module.exports = __webpack_public_path__ + "img/xrfl_get_btn.bf47806e.webp";